/* CUBE STORE - i campi di Magical: dove stanno e come si comportano

   1) OGNI IMPORTO SOTTO LA SUA MODALITA' DI PAGAMENTO

   Magical disegna prima l'elenco dei metodi e poi, tutti in fondo, i
   campi importo dei metodi spuntati. Con sei metodi il cliente
   spuntava in alto e doveva ritrovare la casella in fondo, indovinando
   dall'etichetta a quale delle sue scelte appartenesse. Qui ogni campo
   va a stare subito sotto la casella che lo accende.

   L'abbinamento non e' indovinato: ogni campo condizionato porta in
   data-conditions il nome dell'elenco e il VALORE esatto della casella
   che lo attiva, ed e' la stessa regola con cui l'app decide se
   mostrarlo. Nessun confronto fra testi visibili, che cambierebbero al
   primo ritocco delle etichette in amministrazione.

   condizione() e casellaDiComando() si affacciano su window perche'
   servono anche a cube-importi.js - quali importi sono in bonifico,
   quali appartengono all'acconto, e se quel metodo e' spuntato. Due
   copie dello stesso lettore divergerebbero al primo cambio di
   struttura dell'app.

   2) NELL'ACCONTO SI SCEGLIE UN METODO SOLO

   L'acconto e' un versamento unico, quindi le tre caselle si escludono:
   spuntandone una si spengono le altre. Il saldo resta a scelta
   multipla, che e' il suo senso - li' la cifra si puo' spezzare fra
   piu' metodi.

   QUESTA RIGA E' L'UNICA FONTE DI QUELLA REGOLA, e va saputo perche'
   altrove sembra il contrario. cube-importi.js, quando controlla il
   10% minimo, SOMMA tutti gli importi dell'acconto invece di guardare
   il solo campo acceso, e il suo commento parla di chi versa il 5% per
   bonifico e il 5% con carta - un caso che qui dentro e' impossibile.

   Non e' una svista di nessuno dei due: e' la regola commerciale
   tenuta intera da una parte e ristretta dall'altra. Il minimo del 10%
   riguarda l'acconto, non il singolo metodo, e quel conto resta giusto
   comunque; questa esclusivita' e' una scelta di comodo dell'interfaccia,
   piu' facile da togliere che da rimettere.

   PERCIO' CHI VUOLE PERMETTERE PIU' METODI DI ACCONTO tocca solo
   questo file: basta togliere il ramo UNA_SOLA qui sotto, e
   cube-importi.js e' gia' pronto - non somma "per sbaglio", somma
   perche' quel giorno era previsto. L'unica cosa da non toccare e' lo
   svuotamento del punto 3, che e' cio' che impedisce agli importi
   rimasti indietro di finire nell'ordine.

   Nell'app quel campo e' di tipo Checkboxes, quindi restano quadrate
   anche se ormai si comportano da tonde. Per farle diventare tonde
   davvero basta cambiare il tipo del campo in Magical: qui non
   servirebbe togliere niente, questo codice agisce solo sulle caselle
   di spunta e su dei pallini non farebbe nulla.

   3) TOGLIENDO LA SPUNTA SI SVUOTA L'IMPORTO

   Non era stato chiesto, ma senza questo il resto e' pericoloso. Chi
   scriveva 800 nel bonifico e poi passava alla carta lasciava indietro
   quel valore: il campo spariva dalla vista, ma l'importo restava
   scritto e finiva nell'ordine. Sarebbero arrivati ordini con due
   acconti, uno dei quali mai voluto.

   Vale per tutti e due i moduli e per qualunque casella, non solo per
   l'acconto: lo stesso rischio c'era gia' prima nel saldo.

   LE NOSTRE MODIFICHE NON RIENTRANO DA QUESTA PORTA
   Chi ascolta filtra su isTrusted, cioe' sui gesti di una persona
   vera. Quando siamo noi a togliere una spunta chiamiamo direttamente
   lo svuotamento, e l'evento che mandiamo dopo - quello che serve a
   Magical per nascondere il campo - torna qui e viene ignorato.

   4) LE ISTRUZIONI PRIMA DELLE CASELLE, NON DOPO  (12 agosto 2026)

   Magical mette la descrizione del gruppo come ULTIMO elemento del
   fieldset - misurata: nona posizione su nove, dopo tutte e tre le
   modalita' e dopo i loro campi importo. Ma quella frase dice cosa
   fare ("scegli la modalita' che vuoi utilizzare e l'importo"), e
   un'istruzione letta dopo aver gia' scelto arriva tardi. Qui viene
   portata subito sotto il titolo del gruppo.

   E VIENE SPEZZATA IN DUE, perche' erano due messaggi incollati:
     "Per prenotare la bici e' necessario un acconto di almeno il 10%,
      scegli la modalita' che vuoi utilizzare e l'importo."   -> istruzione
     "Quando riceviamo l'ordine ti invieremo il link per procedere." -> cosa
      succede dopo
   La prima parte resta sotto il titolo del suo gruppo. La seconda
   scende in fondo al modulo, vicino al pulsante, dove serve davvero:
   e' rassicurazione nel momento in cui uno si impegna, non una cosa da
   sapere prima di scegliere. E ci scende UNA VOLTA SOLA: quella stessa
   frase era ripetuta identica in fondo all'acconto e in fondo al saldo.

   IL TAGLIO NON CERCA APOSTROFI. Si cerca "quando riceviamo", due
   parole senza punteggiatura: nel testo dell'app convivono apostrofi
   dritti e tipografici, e una regola che li distinguesse si romperebbe
   al primo ritocco fatto in amministrazione. Se un domani quella frase
   viene riscritta o tolta, non si rompe niente: non trovando il taglio
   la descrizione resta intera sotto il titolo, che e' comunque meglio
   di prima.

   PERCHE' NEL DOM E NON CON IL CSS. Per portare in alto un elemento
   che nel codice sta in fondo servirebbe rendere il fieldset un
   contenitore flex e riordinare con order. Ma un <legend> dentro un
   fieldset flex ha comportamenti diversi da browser a browser, e
   questa e' la finestra da cui passano gli ordini: non e' il posto
   dove tentare. */
(function () {
  var UNA_SOLA = /acconto/i;

  function condizione(campo) {
    var grezzo = campo.getAttribute('data-conditions');
    if (!grezzo) return null;

    var dati;
    try {
      dati = JSON.parse(grezzo);
    } catch (e) {
      return null;
    }

    if (!Array.isArray(dati) || !dati.length || !Array.isArray(dati[0])) return null;

    var prima = dati[0][0];
    if (!prima || prima.relation !== 'equals') return null;
    return prima;
  }

  function scelta(gruppo, cond) {
    var elenchi = gruppo.querySelectorAll('fieldset[data-field-name]');

    for (var i = 0; i < elenchi.length; i++) {
      if (elenchi[i].getAttribute('data-field-name') !== cond.name) continue;

      var caselle = elenchi[i].querySelectorAll('input');
      for (var j = 0; j < caselle.length; j++) {
        if (caselle[j].value === cond.value) return caselle[j];
      }
    }
    return null;
  }

  /* la casella che comanda questo campo, o null: serve a sapere se il
     metodo e' spuntato senza dover guardare se il campo si vede - e un
     campo dentro una finestra chiusa non si vede mai */
  function casellaDiComando(campo) {
    var gruppo = campo.closest ? campo.closest('.ma-custom-field-group') : null;
    if (!gruppo) return null;

    var cond = condizione(campo);
    if (!cond) return null;

    return scelta(gruppo, cond);
  }

  window.cubeCondizioneCampo = condizione;
  window.cubeCasellaDiComando = casellaDiComando;

  /* ---------- lo spostamento ---------- */

  function riordina(gruppo) {
    /* l'ultimo campo appeso a ciascuna casella, per impilare in ordine
       importo e numero di rate */
    var ultimo = new Map();

    gruppo.querySelectorAll('.ma-custom-field[data-conditions]').forEach(function (campo) {
      var cond = condizione(campo);
      if (!cond) return;

      var casella = scelta(gruppo, cond);
      var riga = casella ? casella.closest('.ma-fieldset-option') : null;
      if (!riga) return;

      var ancora = ultimo.get(riga) || riga;
      ultimo.set(riga, campo);

      /* se e' gia' al suo posto non si tocca il DOM: e' cio' che
         impedisce all'osservatore di rincorrere le proprie modifiche */
      if (campo.previousElementSibling === ancora) return;
      ancora.insertAdjacentElement('afterend', campo);
    });
  }

  /* ---------- le istruzioni sotto il titolo, la coda in fondo ---------- */

  function istruzioni(gruppo) {
    gruppo.querySelectorAll('fieldset[data-field-name] > .field-description').forEach(function (nota) {
      var titolo = nota.parentElement.querySelector('legend');
      if (!titolo) return;

      /* il taglio si fa una volta sola per nodo: la marcatura evita che
         l'osservatore, svegliato dalla nostra stessa modifica, ritagli
         un testo gia' tagliato */
      if (nota.dataset.cubeIstruzione !== '1') {
        var testo = nota.textContent.trim();
        var taglio = testo.search(/quando riceviamo/i);

        if (taglio > 0) {
          if (!gruppo.dataset.cubeCoda) gruppo.dataset.cubeCoda = testo.slice(taglio).trim();
          nota.textContent = testo.slice(0, taglio).trim();
        }
        nota.dataset.cubeIstruzione = '1';
      }

      if (titolo.nextElementSibling !== nota) titolo.insertAdjacentElement('afterend', nota);
    });

    var coda = gruppo.dataset.cubeCoda;
    if (!coda) return;

    var gia = gruppo.querySelector(':scope > .cube-dopo');
    if (gia) {
      /* riordina() puo' aver spostato dei campi dopo di lei */
      if (gia !== gruppo.lastElementChild) gruppo.appendChild(gia);
      return;
    }

    var p = document.createElement('p');
    p.className = 'cube-dopo';
    p.textContent = coda;
    gruppo.appendChild(p);
  }

  function run() {
    document.querySelectorAll('.ma-custom-field-group').forEach(function (gruppo) {
      riordina(gruppo);
      istruzioni(gruppo);
    });
  }

  /* ---------- una sola scelta, e niente valori orfani ---------- */

  function svuota(gruppo, nomeElenco, valore) {
    gruppo.querySelectorAll('.ma-custom-field[data-conditions]').forEach(function (campo) {
      var cond = condizione(campo);
      if (!cond || cond.name !== nomeElenco || cond.value !== valore) return;

      campo.querySelectorAll('input[type="text"], input[type="number"]').forEach(function (i) {
        if (!i.value) return;
        i.value = '';
        delete i.dataset.cubeMano;
        delete i.dataset.cubeAuto;
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });

      campo.querySelectorAll('select').forEach(function (s) {
        if (!s.value) return;
        s.selectedIndex = 0;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;

    var casella = e.target;
    if (!casella || casella.type !== 'checkbox' || !casella.closest) return;

    var elenco = casella.closest('fieldset[data-field-name]');
    var gruppo = casella.closest('.ma-custom-field-group');
    if (!elenco || !gruppo) return;

    var nome = elenco.getAttribute('data-field-name') || '';

    if (!casella.checked) {
      svuota(gruppo, nome, casella.value);
      return;
    }

    /* il ramo da togliere per permettere piu' metodi di acconto: vedi
       il punto 2 in testa */
    if (!UNA_SOLA.test(nome)) return;

    elenco.querySelectorAll('input[type="checkbox"]').forEach(function (altra) {
      if (altra === casella || !altra.checked) return;

      altra.checked = false;
      svuota(gruppo, nome, altra.value);

      /* serve a Magical per rinascondere il campo di quel metodo */
      altra.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }, true);

  /* ---------- avvio ---------- */

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      run();
    });
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
